import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_COMPANIES_PAGE_CONTENT,
  FETCH_COMPANIES_PAGE_CONTENT_SUCCESS,
  FETCH_COMPANIES_PAGE_CONTENT_FAILED,
  FETCH_COMPANIES_SEARCH_DATA,
  FETCH_COMPANIES_SEARCH_DATA_SUCCESS,
  FETCH_COMPANIES_SEARCH_DATA_FAILED,
  FETCH_COMPANY_DETAIL,
  FETCH_COMPANY_DETAIL_SUCCESS,
  FETCH_COMPANY_DETAIL_FAILED,
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

export const fetchCompaniesContent = (formData) => (dispatch) => {
  dispatch({
    type: FETCH_COMPANIES_PAGE_CONTENT,
    payload: null,
  });
  http
    .post("companies-page", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      dispatch({
        type: FETCH_COMPANIES_PAGE_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_COMPANIES_PAGE_CONTENT_FAILED,
        payload: error,
      });
    });
};

export const fetchCompaniesData = (post) => (dispatch) => {
  dispatch({
    type: FETCH_COMPANIES_SEARCH_DATA,
    payload: null,
  });
  http
    .post("fetch-companies-data", helpers.doObjToFormData(post))
    .then(({ data }) => {
      // console.log(data)

      window.scrollTo({ top: 800, behavior: "smooth" });
      dispatch({
        type: FETCH_COMPANIES_SEARCH_DATA_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_COMPANIES_SEARCH_DATA_FAILED,
        payload: error,
      });
    });
};

export const fetchCompanyDetails =
  (id, page = 1, limit = 5) =>
  (dispatch) => {
    dispatch({
      type: FETCH_COMPANY_DETAIL,
      payload: { page },
    });

    http
      .post(
        "company-details",
        helpers.doObjToFormData({
          id,
          page,
          limit,
          token: getAuthUserToken(),
        }),
      )
      .then(({ data }) => {
        dispatch({
          type: FETCH_COMPANY_DETAIL_SUCCESS,
          payload: {
            data,
            page,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_COMPANY_DETAIL_FAILED,
          payload: error,
        });
        const { data } = error.response;
        localStorage.removeItem("authToken");
        window.location.reload();
      });
  };
// export const fetchCompanyDetails = (id) => (dispatch) => {
//   dispatch({
//     type: FETCH_COMPANY_DETAIL,
//     payload: null
//   });
//   http
//     .post(
//       "company-details",
//       helpers.doObjToFormData({
//         id: id,
//         token: getAuthUserToken()
//       })
//     )
//     .then(({ data }) => {
//       dispatch({
//         type: FETCH_COMPANY_DETAIL_SUCCESS,
//         payload: data
//       });
//     })
//     .catch((error) => {
//       dispatch({
//         type: FETCH_COMPANY_DETAIL_FAILED,
//         payload: error
//       });
//       const { data } = error.response;
//       localStorage.removeItem("authToken");
//       window.location.reload();
//     });
// };
